import { Pipe, PipeTransform } from '@angular/core';

import { RoutePaths } from '@helper/route-paths';
import { Cart_Item } from '@proto/store/api/store/cart';

@Pipe({ name: 'colorSize', standalone: true })
export class ColorSizePipe implements PipeTransform {
  transform(item: Cart_Item): string {
    const suffix = item.sizeSuffix ? `(${item.sizeSuffix})` : '';
    return `${item.colorName} - ${item.sizeName}${suffix}`;
  }
}

@Pipe({ name: 'productLink', standalone: true })
export class ProductLinkPipe implements PipeTransform {
  transform(skuId: string): string {
    return `/${RoutePaths.PRODUCT}/${skuId}`;
  }
}
